import axios from "axios";
import { useEffect, useState } from "react";
import userStore from "../../../zustand/userStore";
import { WSGetOrgUsers } from "../../../configs/WebService";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import Select from "react-select";
import "./events-responsive.css";

export default function ActivityInput({ index, activity, onChange, onRemove }) {
  const userData = userStore((state) => state.user);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios
      .get(`${WSGetOrgUsers}/${userData.id}`, {
        headers: apiKeyHeader(),
      })
      .then((res) => {
        if (res.data) {
          setUsers(res.data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch users:", err);
      });
  }, []);

  const officerOptions = users.map((user) => ({
    value: user.id,
    label: user.name,
  }));

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "8px",
      border: state.isFocused ? "2px solid #7B2FF7" : "2px solid #e0e0e0",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(123, 47, 247, 0.1)" : "none",
      padding: "2px",
      fontSize: "14px",
      minHeight: "42px",
      "&:hover": {
        borderColor: "#7B2FF7",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#999",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#f0e6ff",
      borderRadius: "4px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#7B2FF7",
      fontWeight: "500",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#7B2FF7",
      "&:hover": {
        backgroundColor: "#7B2FF7",
        color: "#fff",
      },
    }),
  };

  return (
    <div
      className="activity-input-container"
      style={{
        backgroundColor: "#fafbfc",
        padding: "24px",
        borderRadius: "12px",
        marginBottom: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        position: "relative",
        border: "1px solid #eee",
      }}
    >
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "16px",
      }}>
        <label
          style={{
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#333",
            fontSize: "0.95rem",
          }}
        >
          <span style={{
            width: "28px",
            height: "28px",
            background: "linear-gradient(135deg, #7B2FF7 0%, #9B5DE5 100%)",
            color: "#fff",
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.8rem",
            fontWeight: "600",
          }}>
            {index + 1}
          </span>
          Activity
        </label>

        <button
          onClick={onRemove}
          type="button"
          className="activity-remove-btn"
          style={{
            background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "6px 14px",
            cursor: "pointer",
            fontSize: "0.8rem",
            fontWeight: "500",
            boxShadow: "0 2px 6px rgba(220, 53, 69, 0.3)",
            transition: "transform 0.2s, box-shadow 0.2s",
          }}
        >
          Remove
        </button>
      </div>

      <div className="activity-inputs-row" style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: "0.8rem", color: "#666", marginBottom: "6px", display: "block" }}>
            Activity Name
          </label>
          <input
            type="text"
            placeholder="Enter activity name"
            value={activity.activityName ?? activity.name ?? ""}
            onChange={(e) =>
              onChange(index, activity.activityName !== undefined ? "activityName" : "name", e.target.value)
            }
            required
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: "8px",
              border: "2px solid #e0e0e0",
              fontSize: "14px",
              transition: "border-color 0.3s, box-shadow 0.3s",
              outline: "none",
            }}
          />
        </div>

        <div style={{ flex: 1 }}>
          <label style={{ fontSize: "0.8rem", color: "#666", marginBottom: "6px", display: "block" }}>
            Head Officer
          </label>
          <select
            value={activity.headOfficerId}
            onChange={(e) => onChange(index, "headOfficerId", e.target.value)}
            required
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: "8px",
              border: "2px solid #e0e0e0",
              fontSize: "14px",
              backgroundColor: "#fff",
              cursor: "pointer",
              transition: "border-color 0.3s",
              outline: "none",
            }}
          >
            <option value="">Select Head Officer</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ flex: 1 }}>
          <label style={{ fontSize: "0.8rem", color: "#666", marginBottom: "6px", display: "block" }}>
            Assign Users
          </label>
          <Select
            isMulti
            options={officerOptions}
            placeholder="Select users..."
            styles={selectStyles}
            value={(Array.isArray(activity.assigned_users)
              ? activity.assigned_users
              : []
            ).map((user) => ({
              value: user.id,
              label: user.name,
            }))}
            onChange={(selectedOptions) =>
              onChange(
                index,
                "assigned_users",
                selectedOptions.map((opt) => ({
                  id: opt.value,
                  name: opt.label,
                }))
              )
            }
          />
        </div>
      </div>

      <div>
        <label style={{ fontSize: "0.8rem", color: "#666", marginBottom: "6px", display: "block" }}>
          Description
        </label>
        <textarea
          placeholder="Describe the activity..."
          className="activity-textarea"
          value={activity.description}
          onChange={(e) => onChange(index, "description", e.target.value)}
          required
          style={{
            width: "100%",
            padding: "12px 14px",
            borderRadius: "8px",
            border: "2px solid #e0e0e0",
            fontSize: "14px",
            resize: "vertical",
            minHeight: "80px",
            transition: "border-color 0.3s, box-shadow 0.3s",
            outline: "none",
            fontFamily: "inherit",
          }}
        />
      </div>
    </div>
  );
}
